module.exports = __webpack_public_path__ + "img/house.dcb48b8f.svg";